var exports = {
  "Z": "xdde3148b--20b628--layout",
};

module.exports = exports;
